var Curriculog = Curriculog || {};

Curriculog.ManageApiSecrets = (function ($, _, Backbone, ManageApiSecrets, util, dom) {

    var ManageApiSecrets = Curriculog.CurriculogView.extend({
            el: '#key-manager',
            template: 'Api/ApiSecretManager.html',
            events: {
                'click #create-secret-key': 'createKey',
                'click .add-widget': 'generateAccessToken',
                'click .delete-widget': 'deprecateKey',
            },

            initialize: function (options) {
                this.collection = options.collection;
                this.cui_enabled = options.cui_enabled;
            },

            render: function () {
                var el = nunjucks.render(this.template);
                this.replaceElement(el);

                this.keyList = new Curriculog.ApiSecretList({
                    collection: this.collection,
                    cui_enabled: this.cui_enabled
                });
                if (!this.cui_enabled) {
                  objDom.verticalStretchList();
                }
            },

            resetForm: function () {
                $('#secret-key-name').val('');
                this.clearErrors();
            },

            clearErrors: function () {
                $('#keyName-errors').empty().removeClass('active');
            },

            createKey: function (event) {
                event.preventDefault();
                var newKeyName = $('#secret-key-name').val();
                newKeyName = newKeyName.trim().toLowerCase();
                var view = this;

                var newModel = new Curriculog.ApiSecret({name: newKeyName});
                var existingModels = app.apiSecrets.where({name: newKeyName});

                if (!newModel.isValid()) {
                    this.clearErrors();
                    $('#keyName-errors').addClass('active').append('<span>' + newModel.validationError + '</span>');
                } else if (existingModels.length > 0) {
                    this.clearErrors();
                    $('#keyName-errors').addClass('active').append('<span>Key names must be unique</span>');
                } else {
                    this.collection.create(newModel, {
                        wait: true,

                        error: function () {
                            var errorTitle = 'Key Creation Error';
                            var errorText = 'An error was encountered when creating the secret key.  ';
                            errorText += 'Please try again or contact an administrator.';
                            view.showGrowl(errorTitle, errorText);
                        },

                        success: function () {
                            view.resetForm();
                        },
                    });
                }
            },

            generateAccessToken: function (event) {
                event.preventDefault();
                var view = this;
                var listElement = $(event.target).closest('li');

                var keyName = listElement.data('name');
                var keyID = listElement.data('id');

                $.ajax({
                    type: 'GET',
                    url: 'rest/generatetoken/' + keyID,
                    cui_enabled: this.cui_enabled,
                    error: function() {
                        var errorTitle = 'Token Generation Error';
                        var errorText = 'An error was encountered when generating the access token.  ';
                        errorText += 'Please try again or contact an administrator.';
                        view.showGrowl(errorTitle, errorText);
                    },

                    success: function (data) {
                        var templateData = {
                            keyName: keyName,
                            token: data.token,
                        }

                        var selector = '#' + keyID + '-access-token-value';
                        $(selector).html(data.token);
                        $(selector).show();

                        view.clearErrors();
                        if (!this.cui_enabled) {
                          objDom.verticalStretchList();
                        }
                    },
                });
            },

            deprecateKey: function (event) {
                event.preventDefault();
                var listElement = $(event.target).closest('li');

                var keyName = listElement.data('name');
                var keyID = listElement.data('id');
                var keyModel = this.collection.get(keyID);
                var view = this;

                keyModel.destroy({
                    error: function () {
                        // add the model back to the collection if the ajax fails
                        view.collection.add(keyModel);

                        var errorTitle = 'Key Deprecation Error';
                        var errorText = 'An error was encountered when deprecating the secret key.  ';
                        errorText += 'Please try again or contact an administrator.';
                        view.showGrowl(errorTitle, errorText);
                    },
                    success: function () {
                        view.clearErrors();
                    },
                })

            },
    });

    return ManageApiSecrets;

})($, _, Backbone, Curriculog.ManageApiSecrets || {}, Curriculog.util, dom);
